import React from 'react';
// import FindAddress from '../components/FindAddress';
import Login from '../pages/auth/Login';
import NotFound from '../pages/NotFound';
import SignUp from 'pages/auth/SignUp';
import CommonLayout from 'components/Layouts/CommonLayout';
import FindAccount from 'pages/forget/FindAccount';
import TermService from 'pages/terms/TermService';
import PrivacyPolicy from 'pages/terms/PrivacyPolicy';
import PublicVisitRequest from '../pages/publicVisitRequest/PublicVisitRequest';
import NoticeNew from 'pages/NoticeNew';
import VideoPlayer from '../pages/VideoPlayer';

export const ROUTES = {
  HOME: { path: '/', label: 'home', element: <CommonLayout /> },
  MY_PAGE: {
    path: '/my-page',
    label: '마이 페이지',
    element: <CommonLayout />
  },
  SETTING_SYSTEM: {
    path: '/settings/system',
    label: '시스템 설정',
    element: <CommonLayout />
  },
  SETTING_POLICY: {
    path: '/settings/policy',
    label: '정책 관리',
    element: <CommonLayout />
  },
  SETTING_ITEM: {
    path: '/settings/item',
    label: '항목 관리',
    element: <CommonLayout />
  },
  SETTING_GROUP: {
    path: '/settings/group',
    label: '그룹 관리',
    element: <CommonLayout />
  },
  SETTING_USER: {
    path: '/settings/user',
    label: '외부사용자 관리',
    element: <CommonLayout />
  },
  SETTING_EMPLOYEE: {
    path: '/settings/employee',
    label: '임직원 알림 설정',
    element: <CommonLayout />
  },
  HISTORY_USER: {
    path: '/history/user',
    label: '사용자별 로그인 이력 조회',
    element: <CommonLayout />
  },
  HISTORY_SCREEN: {
    path: '/history/screen',
    label: '화면별 접속 이력 조회',
    element: <CommonLayout />
  },
  VISIT_REQUEST: {
    path: '/visit/request',
    label: '내방신청',
    element: <CommonLayout />
  },
  VISIT_REQUEST_ID: {
    path: '/visit/request/:id', // 동적 경로 설정
    label: '내방신청 상세',
    element: <CommonLayout />
  },
  VISIT_REQUEST_HISTORY: {
    path: '/visit/history',
    label: '내방신청 내역',
    element: <CommonLayout />
  },
  VISIT_REQUEST_STATUS: {
    path: '/visit/status',
    label: '내방신청 현황',
    element: <CommonLayout />
  },
  MANUAL: {
    path: '/manual',
    label: '매뉴얼',
    element: <CommonLayout />
  },
  FAQ: {
    path: '/faq',
    label: 'FAQ',
    element: <CommonLayout />
  },
  NOTICE: {
    path: '/notice',
    label: '공지사항',
    element: <CommonLayout />
  },
  NOTICE_NEW: {
    path: '/notice/new',
    label: '새 공지사항 작성',
    element: <CommonLayout />
  },
  NOTICE_ID: {
    path: '/notice/:id',
    label: '공지사항 상세',
    element: <CommonLayout />
  },
  NOTICE_EDIT_ID: {
    path: '/notice/edit/:id',
    label: '공지사항 수정',
    element: <CommonLayout />
  },

  // LOGIN
  LOGIN: { path: '/login', label: '로그인', element: <Login /> },
  SIGNUP: { path: '/signup', label: '회원가입', element: <SignUp /> },
  FINDACCOUNT: { path: '/find-account', label: '아이디/비밀번호 찾기', element: <FindAccount /> },
  LOGIN_AUTH: { path: '/login/auth', label: '-', element: <NotFound /> },
  FIND_PASSWORD: {
    path: '/find-password',
    label: '비밀번호찾기',
    element: <NotFound />
  },
  FIND_PASSWORD_RESET: {
    path: '/find-password/reset',
    label: '비밀번호 초기화',
    element: <NotFound />
  },

  UNAUTHORIZED: {
    path: '/unauthorized',
    label: 'unauthorized',
    element: <NotFound />
  },
  NOT_FOUND: { path: '*', label: '404', element: <NotFound /> },
  TERM_SERVICE: { path: '/term', label: '이용약관', element: <TermService /> },
  PRIVACY_POLICY: { path: '/privacy', label: '개인정보처리방침', element: <PrivacyPolicy /> },

  // 영상 플레이어 (공개)
  VIDEO: { path: '/video', label: '영상', element: <VideoPlayer /> },

  // 내방신청 승인,반려 메일/카톡 버튼용
  PUBLIC_VISIT_REQUEST: { path: '/visit-request/:action/:token/:user', label: '내방신청 승인/반려', element: <PublicVisitRequest /> }
};
